document.addEventListener('DOMContentLoaded', function () {

  function updateWishlistCounter(count) {
    count = parseInt(count, 10) || 0;

    $('.wishlist-counter').each(function () {
      if (count > 0) {
        $(this).text(count).show();
      } else {
        $(this).text('').hide();
      }
    });
  }

  /*
   * Load existing wishlist
   */
  var wishlist_pro = [];

  if (localStorage.getItem('wishlist')) {
    try {
      wishlist_pro = JSON.parse(localStorage.getItem('wishlist')) || [];
    } catch (error) {
      wishlist_pro = [];
      localStorage.removeItem('wishlist');
    }
  }

  /*
   * Keep the saved count in sync with the actual wishlist
   */
  localStorage.setItem('user_wishlist_cnt', wishlist_pro.length);

  /*
   * Check which products are already in wishlist
   */
  $('.wishlist-custom-action').each(function () {

    var attr = $(this).attr('data-handle');

    if ($.inArray(attr, wishlist_pro) >= 0) {
      $(this).addClass('active-wishlist');
      $(this).removeClass('wishlist-custom-action');
    }

  });

  /*
   * Update header wishlist counter
   */
  updateWishlistCounter(wishlist_pro.length);


  /*
   * ADD TO WISHLIST
   */
  jQuery(document).on('click', '.wishlist-custom-action', function (e) {

    e.preventDefault();

    var value = $(this).attr('data-handle');

    /*
     * Get latest wishlist from localStorage
     */
    if (localStorage.getItem('wishlist')) {
      try {
        wishlist_pro = JSON.parse(localStorage.getItem('wishlist')) || [];
      } catch (error) {
        wishlist_pro = [];
      }
    } else {
      wishlist_pro = [];
    }

    /*
     * Add product if it isn't already there
     */
    if ($.inArray(value, wishlist_pro) === -1) {
      wishlist_pro.push(value);
    }

    /*
     * Save wishlist
     */
    localStorage.setItem('wishlist', JSON.stringify(wishlist_pro));
    localStorage.setItem('user_wishlist_cnt', wishlist_pro.length);

    /*
     * Change product button to active
     */
    $(this).removeClass('wishlist-custom-action');
    $(this).addClass('active-wishlist');

    $(".wishlist[data-handle='" + value + "']")
      .addClass('active-wishlist')
      .removeClass('wishlist-custom-action');

    /*
     * Update counter
     */
    updateWishlistCounter(wishlist_pro.length);

  });


  /*
   * REMOVE FROM WISHLIST
   */
  jQuery(document).on('click', '.active-wishlist', function (e) {

    e.preventDefault();

    var to_delete = $(this).attr('data-handle');

    if (!localStorage.getItem('wishlist')) {
      return;
    }

    try {
      wishlist_pro = JSON.parse(localStorage.getItem('wishlist')) || [];
    } catch (error) {
      wishlist_pro = [];
    }

    var index = wishlist_pro.indexOf(to_delete);

    if (index > -1) {

      /*
       * Remove product
       */
      wishlist_pro.splice(index, 1);

      /*
       * Save updated wishlist
       */
      localStorage.setItem('wishlist', JSON.stringify(wishlist_pro));
      localStorage.setItem('user_wishlist_cnt', wishlist_pro.length);

      /*
       * Change product button back
       */
      $(this)
        .removeClass('active-wishlist')
        .addClass('wishlist-custom-action');

      $(".wishlist[data-handle='" + to_delete + "']")
        .removeClass('active-wishlist')
        .addClass('wishlist-custom-action');

      /*
       * Update counter
       *
       * If 0 -> hidden
       * If > 0 -> show number
       */
      updateWishlistCounter(wishlist_pro.length);

    }

  });

});